/**
 * Coarse relative timestamp ("just now", "5m ago", "3h ago", "2d ago")
 * for ages under a week, falling back to the locale date for older
 * timestamps. Empty/missing input returns ''; an unparseable string is
 * returned unchanged so callers never have to guard. Future timestamps
 * (clock skew) collapse to 'just now'.
 */
export function formatRelativeTime(input: string | number | Date | null | undefined): string {
  if (input === null || input === undefined || input === '') return '';
  const date = new Date(input);
  if (Number.isNaN(date.getTime())) return typeof input === 'string' ? input : '';
  const diffMs = Date.now() - date.getTime();
  if (diffMs < 0) return 'just now';
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
}
